const newRelicDummyAgent = {
  // eslint-disable-next-line no-console
  noticeError: (error) => console.log(error),
};

export function getNewRelicAgent() {
  return window.newrelic || newRelicDummyAgent;
}
